export const getChartImageUrl = (chart, imageToken, imageType) =>
  `${process.env.REACT_APP_API_URL}/charts/${
    chart.uuid
  }/image?imageToken=${imageToken}${imageType ? `&type=${imageType}` : ''}`

export default getChartImageUrl
